/**
 * @generated SignedSource<<1017cc63daa07affff9c7f3004bba46c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GraphQLJobRunStatus = "COMPLETED" | "ERRORED" | "IN_PROGRESS" | "PENDING" | "STOPPED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DigestJobDetails_jobRun$data = {
  readonly digestSections: ReadonlyArray<{
    readonly isComplete: boolean;
  }>;
  readonly id: any;
  readonly inputJson: any | null | undefined;
  readonly job: {
    readonly id: any;
    readonly latestPromptFeedback: {
      readonly id: any;
      readonly suggestions: ReadonlyArray<{
        readonly isStale: boolean;
        readonly name: string;
      }>;
    } | null | undefined;
    readonly name: string;
  };
  readonly name: string;
  readonly status: GraphQLJobRunStatus;
  readonly " $fragmentSpreads": FragmentRefs<"DigestSectionAccordion_jobRun" | "JobRunDetails_jobRun">;
  readonly " $fragmentType": "DigestJobDetails_jobRun";
};
export type DigestJobDetails_jobRun$key = {
  readonly " $data"?: DigestJobDetails_jobRun$data;
  readonly " $fragmentSpreads": FragmentRefs<"DigestJobDetails_jobRun">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DigestJobDetails_jobRun",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inputJson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLJobRunDigestOutputSection",
      "kind": "LinkedField",
      "name": "digestSections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isComplete",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLJob",
      "kind": "LinkedField",
      "name": "job",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLPromptFeedback",
          "kind": "LinkedField",
          "name": "latestPromptFeedback",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLPromptSuggestion",
              "kind": "LinkedField",
              "name": "suggestions",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isStale",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DigestSectionAccordion_jobRun"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobRunDetails_jobRun"
    }
  ],
  "type": "GraphQLJobRun",
  "abstractKey": null
};
})();

(node as any).hash = "b2cc576781bd660f6a5dd43043c8dd5c";

export default node;
